import { Plus, PlayCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface PipelineEmptyStateProps {
  onCreateNew: () => void;
}

export function PipelineEmptyState({ onCreateNew }: PipelineEmptyStateProps) {

  return (
    <div className="flex flex-col items-center justify-center py-16 px-4">
      {/* Icon/Illustration */}
      <div className="mb-6 rounded-full bg-primary/10 p-6">
        <PlayCircle className="h-16 w-16 text-primary" />
      </div>

      {/* Message */}
      <h2 className="text-2xl font-semibold mb-2">No pipelines yet</h2>
      <p className="text-muted-foreground text-center max-w-md mb-8">
        Let's create your first ETL pipeline! Build data workflows with our visual
        pipeline builder.
      </p>

      {/* Actions */}
      <div className="flex flex-col sm:flex-row gap-3">
        <Button onClick={onCreateNew} size="lg">
          <Plus className="h-5 w-5 mr-2" />
          Create First Pipeline
        </Button>
        <Button
          variant="outline"
          size="lg"
          onClick={() => window.open('https://docs.example.com/getting-started', '_blank')}
        >
          Watch Tutorial
        </Button>
      </div>

      {/* Helper hint */}
      <p className="text-sm text-muted-foreground mt-8">
        Tip: Start with a simple source → transform → destination flow
      </p>
    </div>
  );
}
